export default {"src":"/_next/static/media/icon-roomLets.5c592fde.svg","height":27,"width":29,"blurWidth":0,"blurHeight":0};